
import { defineComponent } from "vue";

import ReceiverStatsDisplay from "../components/ReceiverStatsDisplay.vue";

import api, {
  ReceiverEventList,
  ReceiverEvent,
  ReceiverStats,
  RequestPaging,
  PageBounding,
  RequestSort,
  RequestParams,
} from "../api/backend-api";
import {
  getSkipParamForPage,
  getPageBounding,
} from "../util/paginationHelpers";
import {
  getHumanDateDiff,
  getHumanDate,
  getHumanDateOffset,
} from "../util/luxonDateHelpers";
import { AxiosError } from "axios";

interface State {
  msg: string;
  receiverAlerts: ReceiverEventList;
  receiverStats: ReceiverStats;
  requestFilter: ReceiverEvent;
  requestPaging: RequestPaging;
  requestSorting: RequestSort;
  pageBounds: PageBounding[];
  errors: AxiosError[];
}

export default defineComponent({
  name: "ReceiverAlert",
  components: {
    ReceiverStatsDisplay
  },
  mounted() {
    this.$nextTick(() => {
      this.getAlertList();
      this.getSystemStats();
    });
  },

  data: (): State => {
    const alert_list = {} as ReceiverEventList;
    const alert_struct = {} as ReceiverEvent;
    const stats_struct = {} as ReceiverStats;
    const paging_struct = {
      Limit: 8,
      Skip: 0,
      Options: [20, 50, 100],
    } as RequestPaging;
    const sort_struct = { Pattern: "-id" } as RequestSort;
    return {
      msg: "Receiver Alerts",
      receiverAlerts: alert_list,
      receiverStats: stats_struct,
      requestFilter: alert_struct,
      requestPaging: paging_struct,
      requestSorting: sort_struct,
      pageBounds: [],
      errors: [],
    };
  },
  methods: {
    getSkipParamForPage,
    getPageBounding,
    getHumanDateDiff,
    getHumanDate,
    getHumanDateOffset,
    haveStatsOrAlerts(): boolean {
      if (this.receiverAlerts.count > 0) {
        return true;
      }
      if (this.receiverStats.actions?.last) {
        return true;
      }
      if (this.receiverStats.alerts?.last) {
        return true;
      }
      if (this.receiverStats.sheqsy?.last) {
        return true;
      }
      if (this.receiverStats.signals?.last) {
        return true;
      }

      return false;
    },
    renderInstantAlertData(data: string) {
      const obj = JSON.parse(data)
      if (obj.Message) {
        return obj.Message;
      }
      if (obj.EmployeeUId) {
        return obj.EmployeeUId;
      }
      if (obj.CompanyUId) {
        return obj.CompanyUId;
      }
    },
    getAlertList() {
      this.receiverAlerts = {} as ReceiverEventList;
      const request_params = {
        Filters: [
          { Filter: 'Class', Match: 'alert' },
          { Filter: 'Condition', In: ['instant', 'closed'] }
        ]
      } as RequestParams;
      api
        .getAlerts(request_params)
        .then((response) => {
          this.receiverAlerts = response.data;
          this.pageBounds = this.getPageBounding(
            this.receiverAlerts.count,
            this.requestPaging.Limit,
            this.requestPaging.Skip
          );
        })
        .then(() => {
          this.getOpenAlertList()
        })
        .catch((error: AxiosError) => {
          this.errors.push(error);
        });
    },
    getOpenAlertList() {
      if (!this.receiverAlerts) {
        this.receiverAlerts = {} as ReceiverEventList;
      }
      api
        .getOpenAlerts()
        .then((response) => {
          if (response.data.count < 1) {
            return
          }
          if (!response.data.items) {
            return
          }
          response.data.items.forEach (openAlert => {
            console.log(openAlert)
            this.receiverAlerts.count++;
            this.receiverAlerts.items?.unshift(openAlert)
          });
        })

    },
    getSystemStats() {
      this.receiverStats = {} as ReceiverStats;
      api
        .getSystemStats()
        .then((response) => {
          this.receiverStats = response.data;
        })
        .catch((error: AxiosError) => {
          this.errors.push(error);
        });
    },
  },
});
